/* ABC Automobiles · lecture du permis de circulation suisse sur le téléphone du client.
   La photo ne quitte jamais l'appareil : préparation de l'image (canvas), lecture Tesseract.js (chargée à la demande),
   puis extraction des cases 21 (marque et type), 23 (châssis), 24 (réception par type) et 36 (1re mise en circulation),
   et du détenteur (nom et adresse, page de gauche) quand il est sur la photo. */
(function (racine) {
  "use strict";
  var MARQUES = ["VW", "VOLKSWAGEN", "AUDI", "BMW", "MERCEDES", "MERCEDES-BENZ", "RENAULT", "DACIA", "PEUGEOT", "CITROEN", "CITROËN", "FIAT", "FORD", "OPEL", "TOYOTA", "SKODA", "ŠKODA", "SEAT", "CUPRA", "HYUNDAI", "KIA", "NISSAN", "MAZDA", "HONDA", "SUZUKI", "SUBARU", "VOLVO", "TESLA", "MINI", "MITSUBISHI", "JEEP", "LAND", "PORSCHE", "SMART", "ALFA", "LANCIA", "CHEVROLET", "DS", "JAGUAR", "LEXUS", "IVECO", "DODGE", "CHRYSLER", "SSANGYONG", "MG", "BYD", "POLESTAR", "SAURER"];
  var WMI = { WVW: "VW", WV1: "VW", WV2: "VW", WAU: "Audi", WUA: "Audi", TRU: "Audi", WBA: "BMW", WBS: "BMW", WBY: "BMW", WDB: "Mercedes-Benz", WDD: "Mercedes-Benz", WDC: "Mercedes-Benz", W1K: "Mercedes-Benz", W1N: "Mercedes-Benz", W1V: "Mercedes-Benz", VF1: "Renault", UU1: "Dacia", VF3: "Peugeot", VR3: "Peugeot", VF7: "Citroën", VR7: "Citroën", ZFA: "Fiat", WF0: "Ford", W0L: "Opel", W0V: "Opel", TMB: "Škoda", VSS: "Seat", SB1: "Toyota", NMT: "Toyota", JTD: "Toyota", JTN: "Toyota", VNK: "Toyota", SJN: "Nissan", JN1: "Nissan", VSK: "Nissan", JMZ: "Mazda", JHM: "Honda", SHH: "Honda", TSM: "Suzuki", KNA: "Kia", KNE: "Kia", U5Y: "Kia", KMH: "Hyundai", TMA: "Hyundai", NLH: "Hyundai", YV1: "Volvo", SAL: "Land Rover", SAJ: "Jaguar", WP0: "Porsche", WP1: "Porsche", WMW: "Mini", ZAR: "Alfa Romeo", WME: "smart", "5YJ": "Tesla", LRW: "Tesla", XP7: "Tesla", JSA: "Suzuki", JF1: "Subaru", JMB: "Mitsubishi" };
  var ETIQUETTES = /^(MARKE|UND|TYP|MARQUE|ET|TYPE|MARCA|E|TIPO|TIP|FAHRGESTELL|NR|CH[AÂ]SSIS|NO|TELAIO|N|SCHASSIS|D|21|23)$/;

  function normaliser(t) { return (t || "").toUpperCase().replace(/[‘’`´]/g, "'").trim(); }
  function propre(t) { return normaliser(t).replace(/^[^A-Z0-9ÀÂÄÉÈÊËÎÏÔÖÙÛÜÇŠ]+|[^A-Z0-9ÀÂÄÉÈÊËÎÏÔÖÙÛÜÇŠ.]+$/g, ""); }
  function centreY(m) { return (m.bbox.y0 + m.bbox.y1) / 2; }

  /* Corrections selon la position : le moteur confond 1/I, 0/O, 5/S, 8/B, 2/Z, 6/G. */
  var VERS_CHIFFRE = { O: "0", D: "0", Q: "0", U: "0", I: "1", L: "1", "|": "1", T: "1", J: "1", Z: "2", S: "5", B: "8", G: "6", A: "4" };
  var VERS_LETTRE = { "0": "O", "1": "I", "2": "Z", "4": "A", "5": "S", "6": "G", "8": "B" };
  function chiffre(c) { return /\d/.test(c) ? c : VERS_CHIFFRE[c] || null; }
  function lettre(c) { return /[A-Z]/.test(c) ? c : VERS_LETTRE[c] || null; }
  /* Mots voisins sur une même ligne, pour recoller « 1VD 123 » ou un châssis coupé en morceaux. */
  function suites(mots, max) {
    var res = [];
    mots.forEach(function (m) {
      var h = m.bbox.y1 - m.bbox.y0, cy = centreY(m);
      var droite = mots.filter(function (n) { return n !== m && n.bbox.x0 >= m.bbox.x1 - h * 0.3 && Math.abs(centreY(n) - cy) < h * 0.6; }).sort(function (a, b) { return a.bbox.x0 - b.bbox.x0; });
      var groupe = [m], dernier = m;
      for (var j = 0; j < droite.length && groupe.length < max; j++) {
        if (droite[j].bbox.x0 - dernier.bbox.x1 > h * 1.6) break;
        groupe.push(droite[j]); dernier = droite[j]; res.push(groupe.slice());
      }
    });
    return res;
  }
  /* Châssis (VIN) : 17 signes, jamais I, O ni Q, les 4 derniers sont des chiffres ; chez la plupart des marques
     les 6 derniers aussi (pas chez Ford, Renault et Dacia, qui y mettent parfois des lettres). */
  var SERIE_LIBRE = { WF0: 1, VF1: 1, UU1: 1 };
  function corrigerVin(t) {
    t = t.replace(/[^A-Z0-9]/g, "");
    if (t.length !== 17 || (t.match(/\d/g) || []).length < 3 || /^[IOQ0]/.test(t)) return null;
    var avant = t;
    t = t.replace(/[IOQ]/g, function (c) { return c === "I" ? "1" : "0"; });
    var debut = WMI[t.slice(0, 3)] && !SERIE_LIBRE[t.slice(0, 3)] ? 11 : 13, c = t.split("");
    for (var j = debut; j < 17; j++) {
      var n = chiffre(c[j]);
      if (j >= 13 && !n) return null;
      if (n && (j >= 13 || "LISBZGOQD|T".indexOf(c[j]) >= 0)) c[j] = n;
    }
    t = c.join("");
    if (!/[A-Z]/.test(t)) return null;
    var corrections = 0; for (var i = 0; i < 17; i++) if (t[i] !== avant[i]) corrections++;
    return corrections <= 3 ? t : null;
  }
  function chassis(mots) {
    var meilleur = null;
    var essai = function (texte, conf, m) { var v = corrigerVin(normaliser(texte)); if (v && (!meilleur || conf > meilleur.c)) meilleur = { v: v, c: conf, m: m }; };
    mots.forEach(function (m) { essai(m.text, m.confidence, m); });
    /* Châssis coupé en morceaux : recollé seulement si le début désigne un constructeur connu (sinon « matricola 180.88.125 » passerait). */
    if (!meilleur) suites(mots, 3).forEach(function (g) {
      if (g.some(function (m) { return /[.,:\/]/.test(propre(m.text)); })) return;
      var v = corrigerVin(normaliser(g.map(function (m) { return m.text; }).join("")));
      if (v && WMI[v.slice(0, 3)]) essai(v, Math.min.apply(null, g.map(function (m) { return m.confidence; })) - 5, g[0]);
    });
    return meilleur;
  }
  /* Réception par type : 1 chiffre, 2 lettres, 3 chiffres (ex. 1TD812, parfois « 1TD 812 »). */
  function corrigerType(t) {
    var m = t.replace(/[^A-Z0-9|]/g, "").match(/^(.)(..)(...)M?$/);
    if (!m) return null;
    var a = chiffre(m[1]), b = m[2].split("").map(lettre), c = m[3].split("").map(chiffre);
    if (!a || a === "0" || b.indexOf(null) >= 0 || c.indexOf(null) >= 0) return null;
    var lettres = m[2].replace(/[^A-Z]/g, "").length, justes = (/\d/.test(m[1]) ? 1 : 0) + lettres + m[3].replace(/[^0-9]/g, "").length;
    return lettres >= 1 && justes >= 4 ? a + b.join("") + c.join("") : null;
  }
  function receptionType(mots, vin) {
    var cands = [];
    var essai = function (texte, conf) { var v = corrigerType(normaliser(texte)); if (v) cands.push({ v: v, c: conf }); };
    mots.forEach(function (m) { if (!(vin && vin.m === m)) essai(m.text, m.confidence); });
    suites(mots, 2).forEach(function (g) { if (!(vin && g.indexOf(vin.m) >= 0)) essai(g[0].text + g[1].text, Math.min(g[0].confidence, g[1].confidence) - 5); });
    cands.sort(function (a, b) { return b.c - a.c; });
    return cands[0] || null;
  }
  function annee(mots) {
    var maintenant = new Date().getFullYear(), yy = maintenant % 100, ancres = mots.filter(function (m) { return /INVERKEHR|CIRCULATION|CIRCOLAZIONE|CIRCULAZIUN/.test(normaliser(m.text)); });
    var dates = [];
    mots.forEach(function (m) {
      var t = normaliser(m.text).split("/")[0].replace(/[^0-9.]/g, ""), r, a;
      if ((r = t.match(/^(\d{2})\.(\d{2})\.(\d{4})$/))) a = +r[3];
      else if ((r = t.match(/^(\d{2})\.(\d{2})\.(\d{2})$/))) a = +r[3];
      else if ((r = t.match(/^(\d{2})\.(\d{4})$/))) a = +r[2];
      else if ((r = t.match(/^(\d{2})\.(\d{2})$/)) && +r[1] >= 1 && +r[1] <= 12) a = +r[2];
      else return;
      if (a < 100) a += a <= yy ? 2000 : 1900;
      if (a >= 1900 && a <= maintenant) dates.push({ a: a, m: m });
    });
    if (!dates.length) return null;
    if (ancres.length) {
      var y = ancres.reduce(function (s, m) { return s + centreY(m); }, 0) / ancres.length, x = Math.max.apply(null, ancres.map(function (m) { return m.bbox.x1; }));
      var proches = dates.filter(function (d) { return d.m.bbox.x0 > x && Math.abs(centreY(d.m) - y) < 4 * (d.m.bbox.y1 - d.m.bbox.y0); });
      if (proches.length) { proches.sort(function (p, q) { return p.m.bbox.x0 - q.m.bbox.x0; }); return proches[0].a; }
    }
    return Math.min.apply(null, dates.map(function (d) { return d.a; }));
  }
  function marqueType(mots, vin) {
    /* Valeur de la case 21 : au milieu des 4 lignes d'étiquette (Marke / Marque / Marca / Marca), jamais le châssis. */
    var ancres = [], choisis = [];
    mots.forEach(function (m) { var t = propre(m.text), l = t === "MARKE" ? 0 : t === "MARQUE" ? 1 : t === "MARCA" ? 2.5 : -1; if (l >= 0) ancres.push({ m: m, l: l }); });
    if (ancres.length) {
      var p = mediane(ancres.map(function (a) { var ra = a.m.line && a.m.line.rowAttributes && a.m.line.rowAttributes.row_height; return ra ? 0.95 * ra : 1.1 * (a.m.bbox.y1 - a.m.bbox.y0); }));
      var yc = mediane(ancres.map(function (a) { return centreY(a.m) + (1.5 - a.l) * p; })), x = Math.max.apply(null, ancres.map(function (a) { return a.m.bbox.x1; }));
      choisis = mots.filter(function (m) { var c = centreY(m); return m.bbox.x0 > x + p * 0.5 && c > yc - 1.3 * p && c < yc + 0.9 * p && m.confidence > 35 && !ETIQUETTES.test(propre(m.text)) && !corrigerVin(normaliser(m.text)); });
    }
    if (!choisis.length) {
      var depart = null;
      mots.forEach(function (m) { if (!depart && MARQUES.indexOf(propre(m.text)) >= 0 && m.confidence > 50) depart = m; });
      if (depart) { var hd = depart.bbox.y1 - depart.bbox.y0; choisis = mots.filter(function (m) { return m.bbox.x0 >= depart.bbox.x0 && Math.abs(centreY(m) - centreY(depart)) < hd * 0.6 && m.confidence > 35 && !corrigerVin(normaliser(m.text)); }); }
    }
    choisis.sort(function (a, b) { return a.bbox.x0 - b.bbox.x0; });
    var k = -1; choisis.forEach(function (m, j) { if (k < 0 && MARQUES.indexOf(propre(m.text)) >= 0) k = j; });
    if (k > 0) choisis = choisis.slice(k);
    var texte = choisis.map(function (m) { return propre(m.text); }).filter(function (t) { return /^[A-Z0-9ÀÂÄÉÈÊËÎÏÔÖÙÛÜÇŠ][A-Z0-9ÀÂÄÉÈÊËÎÏÔÖÙÛÜÇŠ.\-]*$/.test(t); }).slice(0, 6).join(" ").trim();
    if (!texte && vin && WMI[vin.v.slice(0, 3)]) texte = WMI[vin.v.slice(0, 3)];
    return { texte: texte ? joli(texte) : null, mots: choisis };
  }
  function joli(t) { return t.split(" ").map(function (m) { return /^[A-ZÀ-ÜŠ]{4,}$/.test(m) ? m.charAt(0) + m.slice(1).toLowerCase() : m; }).join(" "); }

  function analyser(mots) {
    var vin = chassis(mots), rt = receptionType(mots, vin), mt = marqueType(mots, vin);
    return { marqueType: mt.texte, annee: annee(mots), case24: rt && rt.v, chassis: vin && vin.v, _vin: vin, _marque: mt.mots, _mots: mots };
  }
  /* Zones des cases 21, 23, 24 et 36. Chaque case de la page de droite a son étiquette sur 4 lignes (allemand, français,
     italien, romanche) et sa valeur au milieu ; toutes les cases ont la même hauteur. Chaque étiquette lue situe donc
     sa case, et plusieurs cases lues situent les autres (rang : 15 = −3 … 21 = 0, 23 = 1, 24 = 6, 36 = 10).
     Dernier champ : le mot ouvre-t-il la ligne d'étiquette (sert alors aussi à situer le bord gauche) ? */
  var LIGNES = [
    [/^SCHILD$/, -3, 0, 1], [/^PLAQUE$/, -3, 1, 1], [/^TARGA$/, -3, 2, 1], [/^NUMER$/, -3, 3, 1],
    [/^VERWENDUNG$/, -2, 0, 0], [/^USAGE$/, -2, 1, 1], [/^DIEVER$/, -2, 3, 1],
    [/^FAHRZEUGS$/, -1, 0, 0], [/^V.HICULE$/, -1, 1, 0], [/^VEICOLO$/, -1, 2, 0], [/^VEHICHEL$/, -1, 3, 0],
    [/^MARKE$/, 0, 0, 1], [/^MARQUE$/, 0, 1, 1], [/^MARCA$/, 0, 2.5, 1],
    [/^FAHRGESTELL/, 1, 0, 1], [/^CH.SSIS$/, 1, 1, 1], [/^TELAIO$/, 1, 2, 1], [/^SCHASSIS$/, 1, 3, 1],
    [/^KAROSSERIE$/, 2, 0, 1], [/^CARROSSERIE$/, 2, 1, 1], [/^CARROZZERIA$/, 2, 2, 1], [/^CAROSSARIA$/, 2, 3, 1],
    [/^FARBE$/, 3, 0, 1], [/^COULEUR$/, 3, 1, 1], [/^COLORE$/, 3, 2, 1], [/^COLUR$/, 3, 3, 1],
    [/^PL.TZE$/, 4, 0, 1], [/^PLACES$/, 4, 1, 1], [/^POSTI$/, 4, 2, 1], [/^PLAZS$/, 4, 3, 1],
    [/^STAMMNUMMER$/, 5, 0, 1], [/^MATRICULE$/, 5, 1, 0], [/^MATRICOLA$/, 5, 2, 0], [/^MATRICLA$/, 5, 3, 0],
    [/^TYPENGEN/, 6, 0, 1], [/^R.{0,2}CEPTION$/, 6, 1, 1], [/^APPROVAZIONE$/, 6, 2, 1], [/^APPROVAZIUN$/, 6, 3, 1],
    [/^HUBRAUM$/, 7, 0, 1], [/^CYLINDR.E$/, 7, 1, 1], [/^CILINDRATA$/, 7, 2, 1], [/^CILINDRADA$/, 7, 3, 1],
    [/^LEISTUNG$/, 8, 0, 1], [/^PUISSANCE$/, 8, 1, 1], [/^POTENZA$/, 8, 2, 1], [/^PRESTAZIUN$/, 8, 3, 1],
    [/INVERKEHR/, 10, 0, 0], [/^CIRCULATION$/, 10, 1, 0], [/^CIRCOLAZIONE$/, 10, 2, 0], [/^CIRCULAZIUN$/, 10, 3, 0]
  ];
  var RANGS = { 21: 0, 23: 1, 24: 6, 36: 10 };
  function mediane(t) { t = t.slice().sort(function (a, b) { return a - b; }); return t.length ? t[Math.floor(t.length / 2)] : null; }
  /* Droite des moindres carrés v = a + b·k, en écartant une fois les points trop loin (> ecart). */
  function droite(pts, ecart) {
    var calc = function (t) {
      var km = t.reduce(function (s2, o) { return s2 + o.k; }, 0) / t.length, vm = t.reduce(function (s2, o) { return s2 + o.v; }, 0) / t.length;
      var sk = t.reduce(function (s2, o) { return s2 + (o.k - km) * (o.k - km); }, 0), b = sk ? t.reduce(function (s2, o) { return s2 + (o.k - km) * (o.v - vm); }, 0) / sk : 0;
      return { a: vm - b * km, b: b };
    };
    var f = calc(pts), gardes = pts.filter(function (o) { return Math.abs(o.v - f.a - f.b * o.k) <= ecart; });
    return gardes.length >= 2 && gardes.length < pts.length ? calc(gardes) : f;
  }
  function zones(r, W, H) {
    var obs = [], pas = [];
    r._mots.forEach(function (m) {
      var t = propre(m.text), ra = m.line && m.line.rowAttributes && m.line.rowAttributes.row_height;
      LIGNES.forEach(function (l) {
        if (!l[0].test(t)) return;
        pas.push(ra ? 0.95 * ra : 1.1 * (m.bbox.y1 - m.bbox.y0));
        obs.push({ k: l[1], y: centreY(m), l: l[2], x: l[3] ? m.bbox.x0 : null });
      });
    });
    var p = mediane(pas);
    /* Sans étiquette lue : la valeur du châssis ou de la marque sert de repère (lettres ≈ 1,3 ligne d'étiquette). */
    var valeur = function (mots, k) {
      if (!mots.length) return;
      var h = mediane(mots.map(function (m) { return m.bbox.y1 - m.bbox.y0; }));
      if (!p) p = h / 1.3;
      obs.push({ k: k, y: mediane(mots.map(centreY)) + 0.4 * p, l: 1.5, x: Math.min.apply(null, mots.map(function (m) { return m.bbox.x0; })) - 9.5 * p });
    };
    if (!obs.length) { if (r._vin) valeur([r._vin.m], 1); if (r._marque && r._marque.length) valeur(r._marque, 0); }
    if (!obs.length || !p) return {};
    var rangs = {};
    obs.forEach(function (o) { (rangs[o.k] = rangs[o.k] || []).push(o); });
    var lus = Object.keys(rangs).map(function (k) {
      var t = rangs[k], xs = t.filter(function (o) { return o.x !== null; }).map(function (o) { return o.x; });
      return { k: +k, y: mediane(t.map(function (o) { return o.y + (1.5 - o.l) * p; })), x: xs.length ? mediane(xs) : null };
    });
    var fy = { a: lus[0].y, b: 4.33 * p }, fx = null, avecX = lus.filter(function (o) { return o.x !== null; });
    if (lus.length >= 2) { var f = droite(lus.map(function (o) { return { k: o.k, v: o.y }; }), 1.2 * p); if (f.b > 3.4 * p && f.b < 5.4 * p) fy = f; else fy.a = lus[0].y - 4.33 * p * lus[0].k; }
    else fy.a = lus[0].y - fy.b * lus[0].k;
    if (avecX.length >= 2) fx = droite(avecX.map(function (o) { return { k: o.k, v: o.x }; }), 0.8 * p);
    else if (avecX.length) fx = { a: avecX[0].x, b: 0 };
    if (!fx) return {};
    var res = { p: p }, pente = fy.b ? Math.abs(fx.b / fy.b) : 0;
    [21, 23, 24, 36].forEach(function (n) {
      var k = RANGS[n], lu = lus.filter(function (o) { return o.k === k; })[0];
      var y = lu ? lu.y : fy.a + fy.b * k, x = lu && lu.x !== null ? lu.x : fx.a + fx.b * k, larg = (k <= 1 ? 31 : 15) * p;
      var haut = Math.min(5 * p, 3.4 * p + pente * larg), z = { left: x + 8.95 * p, top: y - haut / 2, width: larg, height: haut };
      if (z.left > W - 3 * p || z.top > H - p || z.top + z.height < p) return;
      z.left = Math.max(0, Math.round(z.left)); z.top = Math.max(0, Math.round(z.top));
      z.width = Math.max(10, Math.min(W - z.left, Math.round(z.width))); z.height = Math.max(10, Math.min(H - z.top, Math.round(z.height)));
      res["z" + n] = z;
    });
    return res;
  }
  /* Détenteur (page de gauche, cases 01-06) : étiquettes « Name, Vornamen / Wohnort », « Nom, prénoms / Domicile »…
     La valeur est à droite : nom, puis rue, puis NPA et localité. */
  var ETIQ_TIT = /^(NAME|VORNAMEN|WOHNORT|NOM|PR.NOMS|DOMICILE|COGNOME|NOMI|DOMICILIO|NUM|PRENUMS|DOMICIL)$/;
  function zoneTitulaire(r, W, H) {
    var a = r._mots.filter(function (m) { return ETIQ_TIT.test(propre(m.text)); });
    if (a.length < 2) return null;
    var p = mediane(a.map(function (m) { var ra = m.line && m.line.rowAttributes && m.line.rowAttributes.row_height; return ra ? 0.95 * ra : 1.1 * (m.bbox.y1 - m.bbox.y0); }));
    var x0m = mediane(a.map(function (m) { return m.bbox.x0; }));
    a = a.filter(function (m) { return Math.abs(m.bbox.x0 - x0m) < 8 * p; });
    var droite = Math.max.apply(null, a.map(function (m) { return m.bbox.x1; }));
    var haut = Math.min.apply(null, a.map(function (m) { return m.bbox.y0; })), bas = Math.max.apply(null, a.map(function (m) { return m.bbox.y1; }));
    /* La page de gauche s'arrête avant la colonne d'étiquettes de la page de droite, si elle est sur la photo. */
    var fin = droite + 54 * p, dr = r._mots.filter(function (m) { return m.bbox.x0 > droite + 10 * p && LIGNES.some(function (l) { return l[3] && l[0].test(propre(m.text)); }); });
    if (dr.length) fin = Math.min(fin, Math.min.apply(null, dr.map(function (m) { return m.bbox.x0; })) - 5 * p);
    var z = { left: droite + 2.2 * p, top: haut - 4.2 * p, width: fin - droite - 2.2 * p, height: bas - haut + 5.4 * p };
    if (z.width < 12 * p) return null;
    z.left = Math.max(0, Math.round(z.left)); z.top = Math.max(0, Math.round(z.top));
    z.width = Math.max(10, Math.min(W - z.left, Math.round(z.width))); z.height = Math.max(10, Math.min(H - z.top, Math.round(z.height)));
    return z;
  }
  var PETITS = /^(DE|DU|DES|LA|LE|LES|L|D|SUR|SOUS|EN|ET|AUX|AU|VON|VAN|DI|DA|DEL|DELLA)$/;
  var ACCENTS = { NEUCHATEL: "Neuchâtel", GENEVE: "Genève", ZURICH: "Zürich", DELEMONT: "Delémont", SAIGNELEGIER: "Saignelégier", CORGEMONT: "Corgémont", BEVILARD: "Bévilard", MOTIERS: "Môtiers", "SAINT-IMIER": "Saint-Imier", "LES PONTS-DE-MARTEL": "Les Ponts-de-Martel" };
  /* « LA CHAUX-DE-FONDS » → « La Chaux-de-Fonds », « RUE DE LA PAIX 12 » → « Rue de la Paix 12 » */
  function enTitre(t) {
    var n = 0;
    return t.toLowerCase().replace(/[a-zà-ÿ]+/g, function (mot, i, tout) {
      var premier = n++ === 0, apres = tout.charAt(i - 1);
      if (!premier && PETITS.test(mot.toUpperCase()) && apres !== "'" && apres !== "’") return mot;
      return mot.charAt(0).toUpperCase() + mot.slice(1);
    });
  }
  function titulaireDe(texte) {
    var lignes = normaliser(texte).split(/\n+/).map(function (l) {
      return l.replace(/[|\[\]{}_~"“”«»]/g, " ").replace(/^[^A-Z0-9ÀÂÄÉÈÊËÎÏÔÖÙÛÜÇ]+/, "").replace(/\s{2,}/g, " ").trim();
    }).filter(function (l) { return l.length >= 3 && /[A-ZÀ-Ü]{2}/.test(l) && !/^(01-06|NAME|VORNAMEN|WOHNORT|NOM,|PR.NOMS|DOMICIL|COGNOME|NUM,|PRENUMS|HALTER|D.TENTEUR)/.test(l); });
    var i, m, iNpa = -1, npa, loc;
    for (i = lignes.length - 1; i >= 1; i--) {
      m = lignes[i].match(/(?:CH-?\s?)?\b([1-9]\d{3})\s+([A-ZÀ-Ü][A-ZÀ-Ü'’.\-]*(?:\s[A-ZÀ-Ü][A-ZÀ-Ü'’.\-]*){0,3})/);
      if (m) { iNpa = i; npa = m[1]; loc = m[2].replace(/(\s\S)+$/, "").replace(/[.\-]+$/, ""); break; }
    }
    if (iNpa < 1) return null;
    var rue = lignes[iNpa - 1], nom = lignes.slice(0, iNpa - 1).join(" ").replace(/[^A-ZÀ-Ü'’\- ]/g, " ").replace(/\s{2,}/g, " ").trim();
    if (!/\d/.test(rue) && !/(RUE|STR|WEG|GASSE|PLATZ|CHEMIN|CH\.|AV|ROUTE|RTE|PLACE|ALL.E|VIA|BOULEVARD|BD|IMPASSE|QUAI|SENTIER|FAUBOURG|CR.T|RAIN|RING|HOF)/.test(rue)) return null;
    if (nom.replace(/[^A-ZÀ-Ü]/g, "").length < 3) return null;
    return { nom: enTitre(nom), rue: enTitre(rue), npa: npa, localite: ACCENTS[loc] || enTitre(loc) };
  }
  function anneeDe(texte) {
    var t = normaliser(texte).replace(/[^0-9.\s]/g, " ").trim(), colle = t.replace(/\s+/g, ""), m, a, maintenant = new Date().getFullYear();
    var mois = function (j, mo) { return (!j || (+j >= 1 && +j <= 31)) && +mo >= 1 && +mo <= 12; };
    if ((m = colle.match(/(\d{2})\.(\d{2})\.(\d{4})(?!\d)/)) && mois(m[1], m[2])) a = +m[3];
    else if ((m = colle.match(/(\d{2})\.(\d{2})\.(\d{2})(?!\d)/)) && mois(m[1], m[2])) a = +m[3];
    else {
      /* Anciens permis : « 03.64 » (mois.année), seulement si c'est tout ce que la case contient. */
      var mots = t.split(/\s+/).map(function (x) { return x.replace(/^\.+|\.+$/g, ""); }).filter(Boolean);
      if (mots.length === 1 && (m = mots[0].match(/^(\d{2})\.(\d{4}|\d{2})$/)) && mois(null, m[1])) a = +m[2];
    }
    if (!a) return null;
    if (a < 100) a += a <= maintenant % 100 ? 2000 : 1900;
    return a >= 1900 && a <= maintenant ? a : null;
  }
  function typeDe(texte) {
    var mots = normaliser(texte).replace(/[^A-Z0-9|\s]/g, " ").split(/\s+/).filter(Boolean);
    for (var i = 0; i < mots.length; i++) { var v = corrigerType(mots[i]) || (mots[i + 1] && corrigerType(mots[i] + mots[i + 1])); if (v) return v; }
    return null;
  }
  function vinDe(texte) {
    var mots = normaliser(texte).replace(/[^A-Z0-9\s]/g, " ").split(/\s+/).filter(Boolean), connu = function (v) { return v && WMI[v.slice(0, 3)] ? v : null; };
    for (var i = 0; i < mots.length; i++) {
      var v = corrigerVin(mots[i]) || (mots[i + 1] && connu(corrigerVin(mots[i] + mots[i + 1]))) || (mots[i + 2] && connu(corrigerVin(mots[i] + mots[i + 1] + mots[i + 2])));
      if (v) return v;
    }
    return null;
  }
  /* Case 21 lue seule : on part de la marque reconnue (sans marque connue, on ne remplit rien). */
  function marqueDe(mots) {
    var t = (mots || []).filter(function (m) { return m.confidence > 45; }).sort(function (a, b) { return a.bbox.x0 - b.bbox.x0; }).map(function (m) { return propre(m.text); })
      .filter(function (x) { return x && !ETIQUETTES.test(x) && /^[A-Z0-9ÀÂÄÉÈÊËÎÏÔÖÙÛÜÇŠ][A-Z0-9ÀÂÄÉÈÊËÎÏÔÖÙÛÜÇŠ.\-]*$/.test(x); });
    var k = -1; t.forEach(function (x, j) { if (k < 0 && MARQUES.indexOf(x) >= 0) k = j; });
    return k < 0 ? null : joli(t.slice(k, k + 6).join(" "));
  }
  /* reconnaitre(options) → Promise des données Tesseract ; options : { psm, liste, zone } */
  function trace(n, d) { if (racine.ABCPermisDebug) console.log("passe   case " + n + " → " + JSON.stringify((d.text || "").trim())); }
  function extraire(reconnaitre, W, H) {
    return reconnaitre({ psm: "11" }).then(function (d1) {
      var r = analyser(d1.words || []), z = zones(r, W, H), suite = Promise.resolve();
      if (racine.ABCPermisDebug) console.log("passe", W + "x" + H, JSON.stringify({ marque: r.marqueType, an: r.annee, c24: r.case24, ch: r.chassis, p: z.p, z21: z.z21, z23: z.z23, z24: z.z24, z36: z.z36 }), (d1.words || []).filter(function (m) { return /\d/.test(m.text) && m.text.length >= 5; }).map(function (m) { return m.text; }).join(" "));
      if (z.z21 && (!r.marqueType || r.marqueType.indexOf(" ") < 0)) suite = suite.then(function () { return reconnaitre({ psm: "7", zone: z.z21 }); }).then(function (d) { trace("21", d); var t = marqueDe(d.words); if (t && (!r.marqueType || (t.length > r.marqueType.length && t.toUpperCase().indexOf(r.marqueType.toUpperCase()) === 0))) r.marqueType = t; });
      if (!r.chassis && z.z23) suite = suite.then(function () { return reconnaitre({ psm: "7", liste: "0123456789ABCDEFGHJKLMNPRSTUVWXYZIOQ", zone: z.z23 }); }).then(function (d) { trace("23", d); var v = vinDe(d.text); if (v) r.chassis = v; });
      if (!r.case24 && z.z24) suite = suite.then(function () { return reconnaitre({ psm: "6", liste: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ ", zone: z.z24 }); }).then(function (d) { trace("24", d); var v = typeDe(d.text); if (v) r.case24 = v; });
      if (z.z36) suite = suite.then(function () { return reconnaitre({ psm: "6", liste: "0123456789./ ", zone: z.z36 }); }).then(function (d) { trace("36", d); var a = anneeDe(d.text); if (a) r.annee = a; });
      var zt = zoneTitulaire(r, W, H);
      if (zt) suite = suite.then(function () { return reconnaitre({ psm: "6", zone: zt }); }).then(function (d) { trace("détenteur", d); r.titulaire = titulaireDe(d.text); });
      return suite.then(function () {
        var ancres = r._mots.filter(function (m) { return /^(MARKE|MARQUE|MARCA|FAHRGESTELL|TYPENGENEHMIGUNG|INVERKEHRSETZUNG)/.test(propre(m.text)); });
        var gauche = ancres.length ? Math.min.apply(null, ancres.map(function (m) { return m.bbox.x0; })) : (r._vin ? r._vin.m.bbox.x0 - 0.12 * W : null);
        return { marqueType: r.marqueType, annee: r.annee, case24: r.case24, chassis: r.chassis, titulaire: r.titulaire || null, _gauche: gauche === null ? null : gauche / W, _p: z.p || null };
      });
    });
  }

  /* --- Navigateur : préparation de l'image et lecture --- */
  function chargerTesseract() {
    if (racine.Tesseract) return Promise.resolve(racine.Tesseract);
    return new Promise(function (ok, ko) { var s = document.createElement("script"); s.src = "https://cdn.jsdelivr.net/npm/tesseract.js@5.1.1/dist/tesseract.min.js"; s.onload = function () { ok(racine.Tesseract); }; s.onerror = ko; document.head.appendChild(s); });
  }
  /* Image de base (redressée si besoin), plafonnée à 3600 px pour la mémoire des téléphones,
     puis recadrée sur le document : le papier, clair, se détache du fond (table, main…). */
  function base(img, tourner) {
    var w = tourner ? img.naturalHeight : img.naturalWidth, h = tourner ? img.naturalWidth : img.naturalHeight, e = Math.min(1, 3600 / Math.max(w, h));
    w = Math.round(w * e); h = Math.round(h * e);
    var c = document.createElement("canvas"); c.width = w; c.height = h;
    var x = c.getContext("2d");
    if (tourner) { x.translate(w, 0); x.rotate(Math.PI / 2); x.drawImage(img, 0, 0, h, w); } else x.drawImage(img, 0, 0, w, h);
    var b = cadrer(c);
    if (!b) return c;
    var r = document.createElement("canvas"); r.width = b.w; r.height = b.h;
    r.getContext("2d").drawImage(c, b.x, b.y, b.w, b.h, 0, 0, b.w, b.h);
    return r;
  }
  function cadrer(c) {
    var pw = 240, ph = Math.max(1, Math.round(c.height * pw / c.width)), p = document.createElement("canvas"); p.width = pw; p.height = ph;
    var x = p.getContext("2d", { willReadFrequently: true }); x.drawImage(c, 0, 0, pw, ph);
    var d = x.getImageData(0, 0, pw, ph).data, lum = new Float32Array(pw * ph), i, tri;
    for (i = 0; i < pw * ph; i++) lum[i] = 0.299 * d[4 * i] + 0.587 * d[4 * i + 1] + 0.114 * d[4 * i + 2];
    tri = Array.prototype.slice.call(lum).sort(function (a, b) { return a - b; });
    var seuil = (tri[Math.floor(tri.length * 0.1)] + tri[Math.floor(tri.length * 0.9)]) / 2;
    if (tri[Math.floor(tri.length * 0.9)] - tri[Math.floor(tri.length * 0.1)] < 40) return null;
    var lignes = [], cols = [], X, Y;
    for (Y = 0; Y < ph; Y++) { var n = 0; for (X = 0; X < pw; X++) if (lum[Y * pw + X] > seuil) n++; lignes.push(n / pw); }
    for (X = 0; X < pw; X++) { var m = 0; for (Y = 0; Y < ph; Y++) if (lum[Y * pw + X] > seuil) m++; cols.push(m / ph); }
    var bornes = function (t, lim) { var a = 0, b = t.length - 1; while (a < b && t[a] < lim) a++; while (b > a && t[b] < lim) b--; return [a, b]; };
    var by = bornes(lignes, 0.35), bx = bornes(cols, 0.35);
    var fx = c.width / pw, fy = c.height / ph, marge = 0.02;
    var x0 = Math.max(0, (bx[0] / pw - marge)) * c.width, x1 = Math.min(1, ((bx[1] + 1) / pw + marge)) * c.width;
    var y0 = Math.max(0, (by[0] / ph - marge)) * c.height, y1 = Math.min(1, ((by[1] + 1) / ph + marge)) * c.height;
    if ((x1 - x0) * (y1 - y0) > 0.85 * c.width * c.height || (x1 - x0) < 0.3 * c.width || (y1 - y0) < 0.3 * c.height) return null;
    return { x: Math.round(x0), y: Math.round(y0), w: Math.round(x1 - x0), h: Math.round(y1 - y0) };
  }
  /* Découpe (zone en fractions), mise à la largeur voulue (2800 px par défaut), puis chaque point est comparé au papier qui l'entoure :
     le fond devient blanc (même sous un reflet ou une ombre), l'écriture noire. */
  function preparer(b, zone, largeur) {
    zone = zone || { x0: 0, y0: 0, x1: 1, y1: 1 };
    var sx = zone.x0 * b.width, sy = zone.y0 * b.height, sw = (zone.x1 - zone.x0) * b.width, sh = (zone.y1 - zone.y0) * b.height;
    var e = Math.min((largeur || 2800) / sw, Math.sqrt(9e6 / (sw * sh))), w = Math.round(sw * e), h = Math.round(sh * e);
    var c = document.createElement("canvas"); c.width = w; c.height = h;
    var x = c.getContext("2d", { willReadFrequently: true });
    x.drawImage(b, sx, sy, sw, sh, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h), p = d.data, n = w * h, g = new Float32Array(n), i;
    for (i = 0; i < n; i++) g[i] = 0.299 * p[4 * i] + 0.587 * p[4 * i + 1] + 0.114 * p[4 * i + 2];
    var r = Math.max(20, Math.round(w / 50)), W1 = w + 1, ii = new Float64Array(W1 * (h + 1));
    for (var yy = 0; yy < h; yy++) { var ligne = 0; for (var xx = 0; xx < w; xx++) { ligne += g[yy * w + xx]; ii[(yy + 1) * W1 + xx + 1] = ii[yy * W1 + xx + 1] + ligne; } }
    for (yy = 0; yy < h; yy++) {
      var a0 = Math.max(0, yy - r), a1 = Math.min(h, yy + r + 1);
      for (xx = 0; xx < w; xx++) {
        var b0 = Math.max(0, xx - r), b1 = Math.min(w, xx + r + 1);
        var s2 = ii[a1 * W1 + b1] - ii[a0 * W1 + b1] - ii[a1 * W1 + b0] + ii[a0 * W1 + b0], moy = s2 / ((a1 - a0) * (b1 - b0));
        var v = 255 - (1 - (g[yy * w + xx] + 8) / (moy + 8)) * 408; v = v < 0 ? 0 : v > 255 ? 255 : v;
        i = 4 * (yy * w + xx); p[i] = p[i + 1] = p[i + 2] = v;
      }
    }
    x.putImageData(d, 0, 0);
    return c;
  }
  function completer(r, z) {
    ["annee", "case24", "chassis", "titulaire"].forEach(function (k) { if (!r[k] && z[k]) r[k] = z[k]; });
    if (z.marqueType && (!r.marqueType || (z.marqueType.length > r.marqueType.length && z.marqueType.toUpperCase().indexOf(r.marqueType.split(" ")[0].toUpperCase()) === 0))) r.marqueType = z.marqueType;
    return r;
  }
  function lireFichier(fichier, progres) {
    return new Promise(function (ok, ko) {
      var img = new Image(), url = URL.createObjectURL(fichier);
      img.onload = function () { URL.revokeObjectURL(url); ok(img); };
      img.onerror = function () { URL.revokeObjectURL(url); ko(new Error("image")); };
      img.src = url;
    }).then(function (img) {
      var etape = 1;
      return chargerTesseract().then(function (T) {
        return T.createWorker("eng", 1, { logger: function (m) { if (progres && m.status === "recognizing text") progres(m.progress, etape); } });
      }).then(function (worker) {
        var lire = function (c) {
          return extraire(function (o) {
            return worker.setParameters({ tessedit_pageseg_mode: o.psm, tessedit_char_whitelist: o.liste || "" }).then(function () {
              return worker.recognize(c, o.zone ? { rotateAuto: true, rectangle: o.zone } : { rotateAuto: true }, { blocks: true, text: true });
            }).then(function (res) { return res.data; });
          }, c.width, c.height);
        };
        /* Le moteur lit le mieux quand une ligne d'étiquette fait ~27 px : permis ouvert (2 pages) sur 2800 px,
           page de droite seule (en hauteur) sur 1500 px ; la première lecture mesure l'écriture et corrige si besoin. */
        var essai = function (tourner) {
          var b = base(img, tourner), L = b.height > b.width * 1.1 ? 1500 : 2800;
          return lire(preparer(b, null, L)).then(function (r) {
            if (r.case24 && r.chassis) return r;
            var deux = b.width > b.height * 1.25, g = r._gauche !== null && r._gauche !== undefined ? r._gauche : (deux ? 0.45 : null);
            var zone = deux && g !== null && g < 0.8 ? { x0: Math.max(0, g - 0.03), y0: 0, x1: 1, y1: 1 } : null;
            etape = 2;
            if (r._p) {
              /* Écriture trop petite ou trop grande : relecture à la bonne taille ; sinon relecture un peu plus grande de la page de droite. */
              var cible = r._p < 17 || r._p > 38 ? 27 : 36, z2 = r._p < 17 || r._p > 38 ? null : zone;
              return lire(preparer(b, z2, L * (z2 ? z2.x1 - z2.x0 : 1) * cible / r._p)).then(function (z) { return completer(r, z); });
            }
            if (!zone) return r;
            return lire(preparer(b, zone, 2800)).then(function (z) { return completer(r, z); });
          });
        };
        return essai(false).then(function (r) {
          if ((r.case24 || r.chassis || r.marqueType) || img.naturalHeight <= img.naturalWidth) return r;
          etape = 1;
          return essai(true);
        }).then(function (r) { worker.terminate(); return r; }, function (e) { worker.terminate(); throw e; });
      });
    });
  }

  racine.ABCPermis = { analyser: analyser, extraire: extraire, lire: lireFichier };
  if (typeof module !== "undefined" && module.exports) module.exports = { analyser: analyser, extraire: extraire, titulaireDe: titulaireDe };
})(typeof window !== "undefined" ? window : globalThis);
